import { EditViewEnum } from '../models/edit-view.enum';
import { ViewTreeNode } from '../../engine/models/view.tree-node';
import { PaintColorModel } from '../models/paint-color.model';
import { ColorRecipeModel } from '../models/color-recipe.model';

export class SetView {
  static readonly type = '[Edit] Set view';
  constructor(public view: EditViewEnum) { }
}

export class NextView {
  static readonly type = '[Edit] Next view';
  constructor() { }
}

export class PreviousView {
  static readonly type = '[Edit] Previous view';
  constructor() { }
}

export class ShowColumns {
  static readonly type = '[Edit] Show columns';
  constructor(public show: boolean) { }
}

export class ShowColumn {
  static readonly type = '[Edit] Show column';
  constructor(public column: 'left' | 'right' | 'header' | 'footer', public show: boolean) { }
}

export class ResetEditPage {
  static readonly type = '[Edit] Reset';
  constructor() { }
}

export class SetObjectVisibility {
  static readonly type = '[Edit] Set object visibility';
  constructor(public nodes: ViewTreeNode[], public visible: boolean) {}
}

export class SetObjectPickable {
  static readonly type = '[Edit] Set object pickable';
  constructor(public nodes: ViewTreeNode[], public pickable: boolean) {}
}

export class SetObjectPaint {
  static readonly type = '[Edit] Set object paint modifications';
  constructor(public nodes: ViewTreeNode[], public paintState: ColorRecipeModel) {}
}
